/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienHomeAboutViewProps } from './obrien-home-about';

export default (props: IObrienHomeAboutViewProps) => {
    const { 
        obAboutBackground, 
        obAboutLogo, 
        obAboutContent, 
        obAboutButtonLink, 
        obAboutButtonText, 
        obCatalogTitle, 
        obCatalogImage, 
        obCatalogButtonLink, 
        obCatalogButtonText, 
        obTeamTitle,
        obIndTeamImage1,
        obIndTeamTitle1,
        obIndTeamImage2,
        obIndTeamTitle2,
        obTeamButtonLink,
        obTeamButtonText
    } = props;
    return (
        <>
        <section className="AboutBanners">
            <div className="App">
                <section id="about-obrien" className="ob-about">
                    {obAboutBackground}
                    <div className="text-container inside-xl">
                        <div>
                            <div>
                                <div className="inside-xxs align-center">
                                    <figure><img src={obAboutLogo} alt="O'Brien Logo"/></figure>
                                </div>
                                <div className="inside-md white-trans" dangerouslySetInnerHTML={{ __html: obAboutContent }}></div>
                            </div>
                            
                            <div className="around-button"><span className="myButton"><a className="button" href={obAboutButtonLink}>{obAboutButtonText}</a></span></div>
                        </div>
                    </div>
                </section>
            </div>
        </section>

        <section className="AboutBelow inside-xl">
            <div className="flex-md justify">
                <div className="forty-five ob-home-catalog">
                    <div className="text-center">
                        <h2>{obCatalogTitle}</h2>
                    </div>
                    <div className="post">
                        <div className="team">
                            {obCatalogImage}
                        </div>
                    </div>
                    <div className="around-button">
                        <span className="myButton">
                            <a href={obCatalogButtonLink} className="button">{obCatalogButtonText}</a>
                        </span>
                    </div>
                </div>
                <div className="forty-five ob-home-teams">
                    <div className="text-center">
                        <h2>{obTeamTitle}</h2>
                    </div>
                    <div className="home-team">
                        <article id={obIndTeamTitle1} className="ob-home-team">
                            <div className="team">
                                {obIndTeamImage1}
                                <div className="team-title">
                                    <h3>{obIndTeamTitle1}</h3>
                                </div>
                            </div>
                        </article>
                        
                        <article id={obIndTeamTitle2} className="ob-home-team">
                            <div className="team">
                                {obIndTeamImage2}
                                <div className="team-title">
                                    <h3>{obIndTeamTitle2}</h3>
                                </div>
                            </div>
                        </article>
                    </div>
                    <div className="around-button">
                        <span className="myButton">
                            <a href={obTeamButtonLink} className="button">{obTeamButtonText}</a>
                        </span>
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
};
